module.exports = __webpack_public_path__ + "static/media/3dep_elevation_viewer.046cfb2f.png";